import PropTypes from 'prop-types';
import { Question } from 'ui';
import React from 'react';
import { RESPONSES } from 'constants/responses';

const valuesApiMapping = {
  Q57: {
    Oui: 'Propriétaire occupant',
    Non: 'Propriétaire non-occupant',
  },

  Q58: {
    Oui: 'Propriétaire bailleur',
    Non: 'Propriétaire non-occupant',
  },
};

export default function Q20(props) {
  const {
    questions,
    whenAnswered,
    state,
    handleState,
    compact,
    node,
    ...rest
  } = props;

  const items = node?.items?.filter(
    (item) => item.isCompact === undefined || item.isCompact === compact,
  );

  const onChange = (e) => {
    handleState({
      situationOccupant: {
        ...state.situationOccupant,
        [e.target.name]: e.target.value,
      },
    });
  };

  const updateQ20 = (e) => {
    const { name, value } = e.target;

    handleState({
      answers: {
        ...state.answers,
        Q20: valuesApiMapping[name][value],
      },
    });
  };

  return (
    <Question
      {...rest}
      node={{ ...node, ...(items ? { items } : {}) }}
      whenAnswered={(e) => {
        onChange(e);

        if (e.target.value === 'Locataire') {
          handleState({
            answers: {
              ...state.answers,
              Q20: 'Locataire',
            },
          });
          whenAnswered({ skippedStep: ['Q27'] });
        }
      }}
      value={state.situationOccupant.Q20}
    >
      <div className="flex flex-col space-y-4">
        {state.situationOccupant.Q20 &&
          state.situationOccupant.Q20 !== 'Locataire' && (
            <>
              <Question
                node={questions.Q57}
                whenAnswered={(e) => {
                  onChange(e);

                  if (e.target.value === RESPONSES.YES) {
                    updateQ20(e);
                    whenAnswered({ skippedStep: ['Q27'] });
                  }
                }}
                value={state.situationOccupant.Q57}
              />

              {state.situationOccupant.Q57 &&
                state.situationOccupant.Q57 === RESPONSES.NO && (
                  <Question
                    node={questions.Q58}
                    whenAnswered={(e) => {
                      onChange(e);
                      updateQ20(e);

                      if (e.target.value === RESPONSES.YES) {
                        whenAnswered({ skippedStep: ['Q27'] });
                      } else {
                        whenAnswered();
                      }
                    }}
                    value={state.situationOccupant.Q58}
                  />
                )}
            </>
          )}
      </div>
    </Question>
  );
}

Q20.propTypes = {
  node: PropTypes.object,
  questions: PropTypes.object,
  whenAnswered: PropTypes.func,
  state: PropTypes.object,
  handleState: PropTypes.func,
  value: PropTypes.string,
  compact: PropTypes.bool,
};
